import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { NzSpinModule } from 'ng-zorro-antd/spin';

/**
 * Indicador de carga, tanto suelto como envolviendo contenido.
 *
 * Envuelve `nz-spin` para sacar el marcado de ng-zorro de las plantillas de feature.
 *
 * `styleClass` existe porque las hojas de estilo aplican reglas de caja (`min-height`) sobre
 * el propio elemento `nz-spin`; una clase en `<app-spin class="...">` caería en el host y no
 * tendría el mismo efecto.
 */
@Component({
  standalone: true,
  selector: 'app-spin',
  imports: [NzSpinModule],
  template: `
    <nz-spin [nzSpinning]="spinning()" [nzSize]="size()" [nzTip]="tip()" [class]="styleClass()">
      <ng-content></ng-content>
    </nz-spin>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppSpinComponent {
  spinning = input<boolean>(true);
  size = input<'small' | 'default' | 'large'>('default');
  /** Texto bajo el indicador. `undefined` deja el spin sin leyenda. */
  tip = input<string | undefined>(undefined);
  /** Clases que deben aplicarse al elemento `nz-spin`, no al host. */
  styleClass = input<string>('');
}
